import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom'
// import { connect } from 'react-redux'
import { FormErrors } from './FormErrors';
import './styles.css'


class FormLogin extends Component {

  constructor(props){
    super(props);
    this.state = {
      type: 'password',
      email: '',
      formErrors: {email: '', password: ''},
      emailValid: false,
      formValid: false
    }
    this.showHide = this.showHide.bind(this);
  }
  
  
  
  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
                  () => { this.validateField(name, value) });
  }
  
  submitForm(e) {
    e.preventDefault()
    const { email } = this.state;
    if ( email.length === 0) {
      alert('Моля, попълнете всички полета')  
    } 
    else {
      this.props.history.push('/programs');
    }
 
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    
    switch(fieldName) {
      case 'email':
        emailValid = value.length>5 && value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? '' : ' is invalid';
        break;
        default:
        break;
    }
    
    this.setState({
      formErrors: fieldValidationErrors,
      emailValid: emailValid,
    }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.emailValid});
  }
  
  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  showHide(e){
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === 'password' ? 'input' : 'password'
    })  
  }

  render() {
    return (
      <div className="form-login">
      
        <form onSubmit={this.submitForm.bind(this)}>
      
          <FormErrors formErrors={this.state.formErrors} classNam="formErrors"/>

          <div className="form-row">
            <div className={`form-group ${this.errorClass(this.state.formErrors.email)}`}>
              <input type="email" placeholder="имейл" className="input" name="email"  value={this.state.email}
              onChange={this.handleUserInput} />
            </div>
          </div>

          <div className="form-row-bttn">
            <input type="submit" value="Изпрати" className="bttn" />
          </div>
      
        </form>
      
      </div>
    )
  }
}

// export default connect()(FormLogin)
export default withRouter(FormLogin)



// WEBPACK FOOTER //
// ./src/components/FormPasswordForgotten/FormPasswordForgotten.js